import { render, staticRenderFns } from "./proposal-tab-pricing-option.vue?vue&type=template&id=22db6fdb"
import script from "./proposal-tab-pricing-option.vue?vue&type=script&lang=js"
export * from "./proposal-tab-pricing-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports